import { useEffect, useRef, useState } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import "../tokens.css"

export const HScroll = ({ className, style, onScroll, children }) => {
  const ref = useRef(null)
  const [overflow, setOverflow] = useState({ right: false, left: false })

  useEffect(() => {
    const el = ref.current
    if (!el) return undefined
    const sync = () => {
      const right = el.scrollWidth > el.clientWidth + 4 && el.scrollLeft + el.clientWidth < el.scrollWidth - 4
      const left = el.scrollLeft > 4
      setOverflow((prev) => (prev.right === right && prev.left === left ? prev : { right, left }))
    }
    sync()
    // Content width changes (rows added, async data) without any scroll/resize event.
    const ro = new ResizeObserver(sync)
    ro.observe(el)
    if (el.firstElementChild) ro.observe(el.firstElementChild)
    el.addEventListener("scroll", sync)
    return () => {
      ro.disconnect()
      el.removeEventListener("scroll", sync)
    }
  }, [])

  const scrollByStep = (dir) => {
    const el = ref.current
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.6, behavior: "smooth" })
  }

  return (
    <div className="ds-hscroll">
      {(overflow.left || overflow.right) && (
        <div className="ds-hscroll-nav" aria-hidden>
          <button
            type="button"
            tabIndex={-1}
            className="ds-hscroll-btn"
            disabled={!overflow.left}
            onClick={() => scrollByStep(-1)}
          >
            <ChevronLeft size={18} />
          </button>
          <button
            type="button"
            tabIndex={-1}
            className="ds-hscroll-btn"
            disabled={!overflow.right}
            onClick={() => scrollByStep(1)}
          >
            <ChevronRight size={18} />
          </button>
        </div>
      )}
      <div
        ref={ref}
        style={style}
        onScroll={onScroll}
        className={[
          "ds-hscroll-scroller",
          className,
          overflow.right ? "is-overflow" : "",
          overflow.left ? "is-overflow-left" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {children}
      </div>
    </div>
  )
}

export default HScroll
